import React, { Children, useState } from "react";
import { Button, Modal } from "antd";
import { cdnUrl } from "@/utils/cdn";
import "./index.less";
interface Props {
  isOpen: boolean;
  setIsOpen: any;
  title: string;
  wrapClassName?: string;
  img?: string;
  children: React.ReactNode;
}
const MyModal = ({ title, img = "", children, isOpen, setIsOpen, wrapClassName = "" }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <Modal
        centered
        wrapClassName={`MyModal ${wrapClassName}`}
        title=""
        closable={false}
        open={isOpen}
        onOk={() => { }}
        onCancel={() => { }}
        footer={null}
      >
        <div className="header">
          <div className="header-left">
            {img && <img src={img} alt="" />}
            <div>{title}</div>
          </div>
          <img
            className="close-icon"
            src={cdnUrl("/img/close-outlined.svg")}
            alt=""
            onClick={() => {
              setIsOpen(false);
            }}
          />
        </div>
        <div className="content">{children}</div>
      </Modal>
    </>
  );
};

export default MyModal;
